import React, { SVGProps } from 'react';

const NeedMoreInfoIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg height="32" width="32" fill="none" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12.9131 12.9129C13.2291 11.5509 14.4697 10.6065 15.8668 10.6644C17.4303 10.5778 18.7707 11.7693 18.868 13.3322C18.868 15.3383 16.0001 16 16.0001 17.3339"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M16.1667 21.0023C16.1666 21.0943 16.0919 21.1689 15.9999 21.1688C15.9079 21.1688 15.8333 21.0942 15.8332 21.0022C15.8332 20.9101 15.9077 20.8355 15.9997 20.8354C16.044 20.8353 16.0865 20.8529 16.1179 20.8842C16.1492 20.9155 16.1667 20.958 16.1667 21.0023"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M6.17083 22.8805C2.59336 17.7742 3.51271 10.7805 8.28831 6.7722C13.0639 2.76393 20.1112 3.07115 24.5198 7.47981C28.9285 11.8885 29.2357 18.9357 25.2274 23.7113C21.2192 28.4869 14.2254 29.4063 9.11909 25.8288L5.32852 26.6711L6.17083 22.8805Z"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default NeedMoreInfoIcon;
